import { gql } from '__generated__'

export const GetUsersByEmail = gql(/* GraphQL */ `
    query GetUsersByEmail($email: String!, $limit: Int, $page: Int) {
        getUsersByEmail(email: $email, limit: $limit, page: $page) {
            data {
                id
                firstName
                nickname
                lastName
                email
            }
            pageInfo {
                pageNumber
                pageTotal
                itemTotal
            }
        }
    }
`)
